import React, { useContext, useEffect, useState } from "react";
import { Grid, Loader } from "rsuite";
import { PropertyStoreContext } from "../../../contexts/PropertyStoreContext";
import { checkIsPilotProperty } from "../../../api";
import LegacyRatePlans from "../rate-plans";
import PropertyConfigHeader from "../PropertyConfigHeader";
import PropertyPageCard from "../PropertyPageCard";
import DerivedRatePlansView from "./DerivedRatePlansView";
import { COPY } from "./constants";
import "../propertyConfig.scss";
import "./ratePlansDerivedRate.scss";

const PILOT_STATUS = {
  LOADING: "loading",
  PILOT: "pilot",
  NOT_PILOT: "not-pilot",
};

// Notion spec: the derived-rate tree view ships to pilot hotels first.
// For all other hotels the existing rate plan page is shown unchanged.
const RatePlansDerivedRate = () => {
  const { selectedProperty } = useContext(PropertyStoreContext);
  const [pilotStatus, setPilotStatus] = useState(PILOT_STATUS.LOADING);

  useEffect(() => {
    if (!selectedProperty?.propertyId) return undefined;

    let cancelled = false;
    setPilotStatus(PILOT_STATUS.LOADING);

    checkIsPilotProperty(selectedProperty.propertyId)
      .then((res) => {
        if (cancelled) return;
        const isPilot = res?.data?.isPilot === true;
        setPilotStatus(isPilot ? PILOT_STATUS.PILOT : PILOT_STATUS.NOT_PILOT);
      })
      .catch(() => {
        if (!cancelled) setPilotStatus(PILOT_STATUS.NOT_PILOT);
      });

    return () => {
      cancelled = true;
    };
  }, [selectedProperty?.propertyId]);

  if (pilotStatus === PILOT_STATUS.NOT_PILOT) {
    return <LegacyRatePlans />;
  }

  if (pilotStatus === PILOT_STATUS.LOADING) {
    return (
      <Grid fluid className="property-config-page rate-plans-derived-rate-page">
        <PropertyConfigHeader title={COPY.PAGE_TITLE} />
        <PropertyPageCard searchPlaceholder={COPY.SEARCH_PLACEHOLDER}>
          <div className="rate-plans-derived-rate-page__pilot-check-loader">
            <Loader size="md" content={COPY.LOADING} />
          </div>
        </PropertyPageCard>
      </Grid>
    );
  }

  return <DerivedRatePlansView />;
};

export default RatePlansDerivedRate;
